function getTotalSize(obj, size){
	for(let key in obj){
		let item = obj[key];
		if(typeof(item) == 'object') {
			size = Number(getTotalSize(item, size));
			
		} else if(key == 'size') {
			if(!item) item = 0;
			size += Number(item);
		} 
	}
	
	return size;
}

//规范图标url
function checkIcon(icon){
	if(icon && icon.substr(0,1) != '/' && icon.substr(0,4) != 'http') return '/' + icon;
	return icon;
}

let opt = {}

export default class config {
	static data			= {};

	static mqtt   		= opt.mqtt;
	static api    		= opt.api;
	static bucket  		= opt.bucket;
	static server		= opt.server;
	static wx			= opt.wx;
	static oss			= opt.oss;
	static shop			= opt.shop;
	static space		= opt.space;
	static avatar		= opt.avatar;
	static cdn			= opt.cdn;
	static origin		= opt.origin;
	
	static phone		= '';
	static id			= '';
	static loaded		= false;
	static needsUpdate	= false;
	static panoUpdate	= false;
	static flyUpdate	= false;
	static modelUpdate	= false;
	
	static init(phone){
		config.phone	= phone;
		config.server	= config.oss + '/resources/';
	}
	
	static setUpdate(type){
		switch(type){
			case 'fly':
				config.flyUpdate = true;
				break;
				
			case 'pano':
				config.panoUpdate = true;
				break;
				
			case 'model':
				config.modelUpdate = true;
				break;
		}
		
		config.needsUpdate = true;
	}
	
	/////////////////////////////////////////////////
	//获取项目资源路径	
	static getPath = (id)=>{
		if(!id) 
			id = config.id;
		else
			config.id = id;
			
		return config.oss + '/vr/' + id + '/';
	}

	//载入数据
	static load = (d, json)=>{
		config.data = d;
		let data = config.data;
		data.searchPano = '';
		data.id				= json.id;
		data.name			= json.name;
		data.description	= json.description	|| '';
		data.author			= json.author 		|| window.localStorage.getItem('nickname') || '';
		data.pv				= json.pv;
		data.resourceId		= json.resourceId	|| json.id;
		data.version		= json.version;
		data.version_t		= json.version_t;
		data.buildStatus	= json.buildStatus;
		data.buildType		= json.buildType;
		data.publish		= json.publish;
		data.publish_time	= json.publish_time;
		data.public			= json.public;
		data.ai				= json.ai;
		data.type			= json.type 		|| 0;
		data.create_time	= json.create_time	|| parseInt(new Date().getTime() / 1000);
		data.panoId			= [];	//绑定页面切换用
		data.modelId		= '';	//绑定页面切换用
		data.cover			= json.cover 		|| {url:'',size:0};
		data.share			= json.share 		|| {url: getPath(json.id)};
		data.storage		= json.storage 		|| 0;
		data.init			= json.init;
		data.music			= json.music;
		data.logo			= json.logo;
		data.buttons		= json.buttons		|| [];
		data.engine			= json.engine		|| (json.resourceId == json.id ? 'default' : 'template');
		data.setting		= json.setting		|| {};
		data.cv				= 5;
		data.splash			= json.splash || {
								type:'img',
								pc : {
									cover 	 : '',
									showType : 1,
								},
								mobile : {
									cover 	 : '',
									showType : 1,
								},
								enter : {
									type 	  : 1,
									stayTime  : 5,
									countdown : true
								},
								background : {
									color : '#232323',
									img   : '',
								},
								
							};
							
		data.plan = json.plan ||{
								floor : [{
									url:'',
									offset : {
										x : 0,
										y : 0,
										z : 0
									},
									rotate : {
										x : 0,
										y : 0,
										z : 0
									},
									scale : {
										x : 1,
										y : 1
									},
									lockRatio : true,
									size : 0,
								}],
								
								grid : false,			//显示网格
								planAtDolly : true,		//3D显示平面图
								modelOpacity: 100,		//平面视图的透明度
								mark : []
							}
							
		//修复旧的平面图数据，
		for(let i=0;i<data.plan.floor.length;i++){
			let item = data.plan.floor[i];
			if('img' in item){
				item.url = item.img;
				delete item.img;
			}
		}
		
		////////////////////////////////////////////////////////////////////////////
		//导览数据
		data.guides = json.guides || json.guide || [];
		
		
		////////////////////////////////////////////////////////////////////////////
		//旧版导览数据
		data.navigation = json.navigation	|| {data:[], setting:{}};
		//if(data.navigation.setting.open  	 == undefined) data.navigation.setting.open  	 = true;		//进入作品打开导览
		if(data.navigation.setting.movie 	 == undefined) data.navigation.setting.movie     = false;		//电影模式
		if(data.navigation.setting.loop 	 == undefined) data.navigation.setting.loop 	 = true;		//自动循环
		if(data.navigation.setting.stoppable == undefined) data.navigation.setting.stoppable = true;		//允许打断
		if(data.navigation.setting.showList  == undefined) data.navigation.setting.showList  = false;		//导览默认打开列表
		if(data.navigation.setting.showMore  == undefined) data.navigation.setting.showMore  = true;		//显示热点
		//兼容旧版数据
		let naviHotspotJson = {
			url		 : 1,
			contacts : 2,
			images	 : 3,
			text	 : 4,
			videos	 : 5,
			panoId	 : 6,
			models	 : 7,
			pdfs	 : 8,
			docs	 : 9,
			musics	 : 10,
			wxId	 : 11,
			none	 : 0,
		} 
		let naviSettingHotspot = data.navigation.setting.hotspot;
		if(naviSettingHotspot == undefined){
			naviSettingHotspot = data.navigation.setting.hotspot = {			//热点类型是否显示
				1  : true,
				2  : true,
				3  : true,
				4  : true,
				5  : true,
				6  : true,
				7  : true,
				8  : true,
				9  : true,
				10 : true,
				11 : true,
				0  : true
			};
		}else if(naviSettingHotspot && naviSettingHotspot.url!=undefined){	//兼容旧版数据
			for(let k in naviSettingHotspot){
				let val = naviSettingHotspot[k];
				delete naviSettingHotspot[k];
				naviSettingHotspot[naviHotspotJson[k]] = val;
			}
		}
		// console.log('config',naviSettingHotspot);
		
		//生成模型配置
		data.build			= json.build || {
			floor	: true,
			cleanup	: true,
			mode	: 0,
			size	: 2,
		}
		
		if(data.build.size == undefined){
			data.build.size = 2;
		}
		
		if(data.buildType == undefined){
			data.buildType = 0;
		}
		
		if(data.init.outside == undefined){
			data.init.outside = false;
		}
	
		// data.switchMode	= json.switchMode || {
		// 											pano:{
		// 												icon:'/images/hotspot/10/13.png',
		// 												iconType:1,
		// 												name:'切换到航拍',
		// 												panoId:'',				//目标场景ID
		// 												panoName:'',			//目标场景名称
		// 												setPano:0,				//是否设置为切换到目标场景
		// 											},
		// 											fly:{
		// 												icon:'/images/hotspot/15/35.png',
		// 												iconType:1,
		// 												name:'切换到室内',
		// 												panoId:'',				//目标场景ID
		// 												panoName:'',			//目标场景名称
		// 												setPano:0,				//是否设置为切换到目标场景
		// 											}
		// 										};
				
		//data.init.backgroundColor	= json.init.backgroundColor || '#636875';
		
		data.hotspots	= json.hotspots			|| [];
		data.panos 		= json.panos;
		data.models		= json.models;
		data.walks		= json.walks;
		data.labels		= json.labels;
		data.groups		= json.groups			|| [];
		data.tags		= json.tags;
		data.userTags	= json.userTags;
		data.tiles		= json.tiles;
		data.repairs	= json.repairs 			|| [];
		
		///////////////////////////////////////////////////////////////
		//基础默认设置
		!data.init.mode 	 && (data.init.mode		 = 'pano');
		!data.pv			 && (data.pv			 = 0);
		!data.logo.url		 && (data.logo.url		 = '');		
		!data.logo.zoom		 && (data.logo.zoom		 = 100);
		!data.logo.clickType && (data.logo.clickType = 0);
		!data.logo.openType  && (data.logo.openType  = 0);
		
		if(data.init.mode == 'model') data.init.mode = 'pano';
		
		if(data.init.flyModelMode	  == undefined) data.init.flyModelMode	   = 1;			//航拍模型类型
		if(data.init.showButtons	  == undefined) data.init.showButtons	   = true;		//显示自定义按钮
		if(data.init.showMap		  == undefined) data.init.showMap		   = true;		//显示小地图
		if(data.init.showCompass	  == undefined) data.init.showCompass 	   = true;		//显示指南针
		if(data.init.showLike		  == undefined) data.init.showLike 		   = true;		//显示点赞
		if(data.init.showComment	  == undefined) data.init.showComment 	   = true;		//显示评论
		if(data.init.antialias		  == undefined) data.init.antialias		   = true;		//抗锯齿
		if(data.init.showLogo 	 	  == undefined) data.init.showLogo 	   	   = 1;	
		if(data.init.showDy3d	  	  == undefined) data.init.showDy3d	   	   = true;		//DY3D版权信息
		if(data.init.showGuide	  	  == undefined) data.init.showGuide	   	   = true;		//显示导览按钮
		if(data.init.showLoading 	  == undefined) data.init.showLoading 	   = 1;			//显示加载图标
		if(data.init.loading		  == undefined) data.init.loading 		   = {
																					type  : 0,
																					url	  : '',
																					color : '#ffffff',
																					backgroundColor : '#000000',
																				}
		if(data.init.search == undefined) {
			data.init.search = {
				enable			: true,
				pano			: true,
				hotspot_link	: true,
				hotspot_phone	: true,
				hotspot_image	: true,
				hotspot_text	: true,
				hotspot_video	: true,
				hotspot_pano	: true,
				hotspot_model	: true,
				hotspot_pdf		: true,
				hotspot_doc		: true,
				hotspot_audio	: true,
				hotspot_none	: true,
			}
		}
		
		
		// data.init.autoRotate		== undefined && (data.init.autoRotate		= true);
		// data.init.autoRotateTime	== undefined && (data.init.autoRotateTime	= 3);
		// data.init.autoRotateSpeed	== undefined && (data.init.autoRotateSpeed	= 140);
		// data.init.autoRotateReviseY	== undefined && (data.init.autoRotateReviseY= true);
		// data.init.autoView			== undefined && (data.init.autoView			= false);
		// data.init.autoViewTime		== undefined && (data.init.autoViewTime		= 5);
		// data.init.autoRotateRight	== undefined && (data.init.autoRotateRight	= 0);
		// data.init.keepView			== undefined && (data.init.keepView			= true);
		
		/////////////////////////////////////////////////////////////////
		//行走漫游全局设置
		// !data.init.moveSpeed	&& (data.init.moveSpeed = 3);
		// !data.init.easing		&& (data.init.easing	= 'Quadratic');
		
		/////////////////////////////////////////////////////////////////
		//航拍切换按钮数据
		if(!data.init.switchMode){
			data.init.switchMode = {
				pano:{
					icon		: '/images/hotspot/10/13.png',
					name		: '切换到航拍',
					type		: 1,
				},
				fly:{
					icon		:'/images/hotspot/15/35.png',
					name		: '切换到室内',
					type		: 1,
				}
			}
		}
		
		///////////////////////////////////////////////////////////////////
		//旧数据处理(升级到新格式)
		if(data.init.switchMode.pano.type != undefined){
			data.init.switchMode.pano.iconType = data.init.switchMode.pano.type;
			delete data.init.switchMode.pano.type;
		}
		
		if(data.init.switchMode.fly.type != undefined){
			data.init.switchMode.fly.iconType = data.init.switchMode.fly.type;
			delete data.init.switchMode.fly.type;
		}
		
		if(data.init.switchMode.pano.setPano 	!=undefined) delete data.init.switchMode.pano.setPano;
		if(data.init.switchMode.pano.panoName 	!=undefined) delete data.init.switchMode.pano.panoName;
		if(data.init.switchMode.fly.setPano 	!=undefined) delete data.init.switchMode.fly.setPano;
		if(data.init.switchMode.fly.panoName 	!=undefined) delete data.init.switchMode.fly.panoName;
		
		//导览按钮
		if(!data.init.naviBtn){
			data.init.naviBtn = {
				icon			: '/images/hotspot/5/1.png',
				iconType		: 1,
				name			: '导览讲解',
				color			: '#FFFFFF',
				backgroundColor	: 'rgb(99, 120, 231)',
				backgroundAlpha : 70,
			}
		}
		if(data.init.naviBtn.backgroundAlpha==undefined) data.init.naviBtn.backgroundAlpha = 70;
		//////////////////////////////////////////////////////////////
		//旧数据升级到V5数据格式
		if(!data.init.pano){
			//如果没有data.init.icon则说明是很早的项目没有相关设置项，直接生成新的
			if(!data.init.icon){
				//室内漫游
				data.init.pano = {
					rotate : {
						auto	: true,
						time	: 3,
						speed	: 140,
						reviseY	: true,
						right	: 0,
					},
					walk : {
						auto	: false,
						time	: 5,
						speed	: 3,
						keepView: true,
						easing	: 'Quadratic',
					},
					icon : {
						show	: true,
						showName: false,
						normal	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.4,
							color	: '',
							icon	: '/images/panospot/1/1.png',
						},
						current	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.4,
							color	: '',
							icon	: '/images/panospot/1/4.png',
						},
						cursor	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.6,
							color	: '',
							icon	: '/images/panospot/1/8.png',
						}
					}
				}
				
				//航拍漫游
				data.init.fly = {
					rotate : {
						auto	: true,
						time	: 3,
						speed	: 140,
						reviseY	: false,
						right	: 0,
					},
					walk : {
						auto	: false,
						time	: 5,
						speed	: 3,
						keepView: false,
						easing	: 'Quadratic',
					},
					icon : {			
						show	: true,
						showName: false,
						normal	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.8,
							color	: '',
							icon	: '/images/panospot/1/10.png',
						},
						current	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.3,
							color	: '',
							icon	: '/images/panospot/1/4.png',
						},
						cursor	: {
							type	: 1,
							scale	: 1,
							alpha	: 0.6,
							color	: '',
							icon	: '/images/panospot/1/5.png',
						}
					},
				}
			} else {
				//如果有data.init.icon则升级到新格式
				const icon = data.init.icon;
				
				icon.fly.current.icon	= checkIcon(icon.fly.current.icon);
				icon.fly.cursor.icon	= checkIcon(icon.fly.cursor.icon);
				icon.fly.normal.icon 	= checkIcon(icon.fly.normal.icon);
				
				icon.pano.current.icon	= checkIcon(icon.pano.current.icon);
				icon.pano.cursor.icon	= checkIcon(icon.pano.cursor.icon);
				icon.pano.normal.icon	= checkIcon(icon.pano.normal.icon);
				
				//室内漫游
				data.init.pano = {
					icon : icon.pano,
					rotate : {
						auto	: data.init.autoRotate,
						time	: data.init.autoRotateTime 		|| 3,
						speed	: data.init.autoRotateSpeed 	|| 140,
						reviseY	: data.init.autoRotateReviseY	|| true,
						right	: data.init.autoRotateRight		|| 0,
					},
					walk : {
						auto	: data.init.autoView			|| false,
						time	: data.init.autoViewTime		|| 5,
						speed	: data.init.moveSpeed			|| 3,
						keepView: data.init.keepView			|| true,
						easing	: data.init.easing,
					},
				}
				
				//航拍漫游
				data.init.fly = {
					icon : icon.fly,
					rotate : {
						auto	: data.init.autoRotate,
						time	: data.init.autoRotateTime 		|| 3,
						speed	: data.init.autoRotateSpeed 	|| 140,
						reviseY	: data.init.autoRotateReviseY	|| true,
						right	: data.init.autoRotateRight		|| 0,
					},
					walk : {
						auto	: data.init.autoView			|| false,
						time	: data.init.autoViewTime		|| 5,
						speed	: data.init.moveSpeed			|| 3,
						keepView: data.init.keepView			|| true,
						easing	: data.init.easing,
					},
				}
				
				delete data.init.icon;
			}
			
			//////////////////////////////////////////////////////////
			//如果有已经抛弃的旧数据则删除
			delete data.init.panoSpot;
			delete data.init.flySpot;
			delete data.init.showPanoName;
			delete data.init.showPanospot;
			delete data.init.showFlyName;
			delete data.init.showFlyspot;
			delete data.init.moveSpeed;
			delete data.init.easing;
			delete data.init.autoload;
			delete data.init.antialias;
			delete data.init.autoRotate;
			delete data.init.autoRotateReviseY;
			delete data.init.autoRotateRight;
			delete data.init.autoRotateSpeed;
			delete data.init.autoRotateTime;
			delete data.init.autoView;
			delete data.init.autoViewTime;
			delete data.init.keepView;
			delete data.init.fov;
		}
		
		///////////////////////////////////////////////////////
		//初始视角数据
		if(data.init.rangeCtrl!=undefined){
			data.init.fovData.pano.rangeCtrl = data.init.rangeCtrl;
			delete data.init.rangeCtrl;
		}  
		if(data.init.max){
			data.init.fovData.pano.max = data.init.max;
			delete data.init.max;
		}
		if(data.init.min){
			data.init.fovData.pano.min = data.init.min;
			delete data.init.min;
		}
		if(!data.init.fovData) {
			data.init.fovData = {
				fly : {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 1},
					rangeCtrl : false,
				},
				pano : {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 1},
				},
				normal : {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 1},
				},
				dolly : {
					fov		: 90,
					image	: '',
					lookat	: {x:3, y:20, z:3},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 0},
				},
			}
		} else {
			if(data.init.fovData.rangeCtrl!=undefined){		//修复视角范围操作数据
				data.init.fovData.pano.rangeCtrl = data.init.fovData.rangeCtrl;
				delete data.init.fovData.rangeCtrl;
			} 
			
			let fovData = data.init.fovData;
			
			if(!fovData.fly){
				fovData.fly = {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:0},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 1}
				}
			}
			
			if(!fovData.fly.model){
				fovData.fly = {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:-1.6, z:0},
					offset  : {x: 0, y: 0, z:0}
				}
			}
			
			if(!fovData.pano.model){
				fovData.pano = {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:-1.6, z:0},
					offset  : {x: 0, y: 0, z:0}
				}
			}
			
			if(!fovData.normal){
				fovData.normal = {
					fov		: 95,
					image	: '',
					lookat	: {x:0, y:0, z:-1},
					model	: {x:0, y:-1.6, z:0},
					offset  : {x: 0, y: 0, z:0}
				}
			}
			
			if(!fovData.dolly.model){
				fovData.dolly = {
					fov		: 90,
					image	: '',
					lookat	: {x:3, y:20, z:3},
					model	: {x:0, y:0, z:0},
					offset  : {x: 0, y: 1.6, z: 0}
				}
			}
			
			if(fovData.pano.lookat.x == 0 && fovData.pano.lookat.y == 0 && fovData.pano.lookat.z == 0){
				fovData.pano.lookat.x	= 0;
				fovData.pano.lookat.y	= 0;
				fovData.pano.lookat.z	= -1;
			}
			
			if(fovData.pano.model.x == 0 && fovData.pano.model.y == 0 && fovData.pano.model.z == 0){
				fovData.pano.model.x	= 0;
				fovData.pano.model.y	= -1.6;
				fovData.pano.model.z	= 0;
			}
			
			fovData.pano.offset.x = 0;
			fovData.pano.offset.y = 0;
			fovData.pano.offset.z = 0;
		}

		
		function oldVersion(){
			if(!json.editorVersion) json.editorVersion = '1.0.0';
			let ver = json.editorVersion.split('.');
			if(ver[0] > 1) return false;
			if(ver[1] > 11) return false;
			if(ver[2] > 72) return false;
			
			return true;
		}
		
		//////////////////////////////////////////////////////////////////////
		//处理热点数据
		for(let key in data.hotspots){
			let item = data.hotspots[key];
			if(item.line == undefined) item.line = { width:2, color:'#ffffff', offset:{x:0, y:0, z:0}}
			if(item.line.offset == undefined) item.line.offset = {x:0, y:0, z:0}
			if(item.radius == undefined) item.radius = 15;
			
			if(item.line.size) {
				item.line.width = item.line.size;
				delete item.line.size;
			}
			
			if(item.line.position){
				item.line.offset = item.line.position;
				delete item.line.position;
			}
			
			if(item.iconType == 4 && item.loop == undefined){
				item.loop = true;
			}
			
			if(item.verticalAlign == undefined){
				item.verticalAlign = 0;
			}
			
			if(oldVersion()){
				item.rotate.x *= 180 / Math.PI;
				item.rotate.y *= 180 / Math.PI;
				item.rotate.z *= 180 / Math.PI;
			}
			
			item.mode = item.mode==false? 0 : (item.mode==true ? 1 : item.mode);
		}
		
		//////////////////////////////////////////////////////////////////////
		//全景数据
		for(let key in data.panos){
			let item = data.panos[key];
			if(!item.brightness) item.brightness = 1.0;
			if(!item.saturation) item.saturation = 1.1;
			if(!item.contrast) item.contrast = 1.1;
			if(!item.northImage) item.northImage = '';

			//修复2023.9月发布的版本Y轴旋转写到Z轴上的问题
			if(!json.editorVersion
			&& item.rotate.z
			&& !item.rotate.x
			&& !item.rotate.y){
				item.rotate.y = item.rotate.z;
				item.rotate.z = 0;
			}
			if(item.mode == undefined){
				item.mode = item.gps ? 1 : 0;
			}
			
			if(item.terrain == undefined){
				item.terrain = item.walk && !!item.gps;
			}
			
			// if(oldVersion()){
			// 	item.rotate.x *= 180 / Math.PI;
			// 	item.rotate.y *= 180 / Math.PI;
			// 	item.rotate.z *= 180 / Math.PI;
			// }
		}
		
		delete data.panoGroup;
		
		//////////////////////////////////////////////////////////////////////
		//模型数据
		data.models.forEach(v=>{
			if(v.sync == undefined) v.sync = true;
			
			if(!v.scale){
				v.scale = {x:1, y:1, z:1};
			} else if(v.scale.val){
				v.scale.x = v.scale.val;
				v.scale.y = v.scale.val;
				v.scale.z = v.scale.val;
				delete v.scale.val;
			}
		})
		
		//////////////////////////////////////////////////////////////////////
		//分组数据
		data.groups.forEach(v=>{
			if(v.mode == undefined) v.mode = 0;
		})
		
		/////////////////////////////////////////////////////////////////////
		//默认按钮数据
		data.init.showShare == undefined && (data.init.showShare = true);
		data.init.showFullscreen == undefined && (data.init.showFullscreen = true);
		
		config.loaded = true;
		return data;
	}
	
	//输出json数据
	static toJSON = ()=>{
		let data = config.data;
		
		let json = {};
		json.author 		= '';
		json.id 			= data.id;
		json.author			= data.author 		|| '';
		json.pv				= data.pv 			|| 0;
		json.resourceId		= data.resourceId 	|| data.id;
		json.version		= data.version 		|| 1;
		json.version_t		= data.version_t  	|| data.ver_t || 0;
		json.buildStatus	= data.buildStatus;
		json.buildType		= data.buildType;
		json.publish		= data.publish;
		json.publish_time	= data.publish_time;
		json.ai				= data.ai;
		json.create_time	= data.create_time || parseInt(new Date().getTime() / 1000);
		
		//////////////////////////////////////////////
		//build
		json.build			= data.build;
		
		/////////////////////////////////////////////////////////////////
		//base
		json.music			= data.music || {};
		json.init			= data.init || {};
		json.init.backgroundColor = data.init.backgroundColor;	//background color
		json.name			= data.name;	//project name
		json.description	= data.description;	//project desc
		json.littleStar		= data.littleStar;	//little star
		json.public			= data.public;	//public
		json.type			= parseInt(data.type);	//type
		json.logo			= data.logo;
		json.buttons		= data.buttons;
		json.tags			= data.tags;
		json.userTags		= data.userTags;
		json.cover			= data.cover || {};
		json.share			= data.share || {url:''};
		json.walks			= data.walks;
		json.groups			= data.groups;
		json.repairs		= data.repairs;
		json.hotspots		= data.hotspots || [];
		json.switchMode 	= data.switchMode;
		json.flySpot		= data.flySpot;
		json.panoSpot		= data.panoSpot;
		json.navigation		= data.navigation || [];
		json.splash			= data.splash || {};
		json.plan			= data.plan || {};
		
		json.guides			= [];
		for(let key in data.guides){
			let item = data.guides[key];

			json.guides.push({
				id 			: item.id,
				name		: item.name,
				path		: item.path,
				pause		: item.pause,
				loop		: item.loop,
				showHotspot	: item.showHotspot,
			});
		}
		
		json.panos	= [];
		for(let key in data.panos){
			let item = data.panos[key];
			
			json.panos.push({
				id			: item.id,
				name		: item.name,
				originName	: item.originName || item.name ||'',
				levels		: item.levels,
				fovImg		: item.fovImg,
				fov			: item.fov,
				lookat		: item.lookat,
				offset		: item.offset,
				rotate		: item.rotate,
				status		: item.status,
				size		: item.size,
				type		: item.type,
				gps			: item.gps,
				terrain		: item.terrain != undefined ? item.terrain : (item.walk && !!item.gps),
				fillColor	: item.fillColor,
				saturation	: item.saturation || 1,
				brightness	: item.brightness || 1,
				mode		: item.mode		  || 0,
				contrast	: item.contrast   || 1,
				northImage	: item.northImage || '',
				url			: item.url || (this.oss + '/vr/'+data.id+'/tiles/'+item.id+'/preview.jpg'),
				update_time	: item.update_time,
				video		: item.video,
				walk		: item.walk,
				refer		: item.refer,
				noTexture	: item.noTexture,
				repeated	: item.repeated,
			});
		}
		
		json.models	= [];
		for(let key in data.models){
			let item = data.models[key];
			json.models.push({
				id			: item.id,
				name		: item.name,
				originName	: item.originName || item.name || '',
				fileType	: item.fileType,
				offset		: item.offset,
				rotate		: item.rotate,
				scale		: item.scale,
				status		: item.status,
				size		: item.size,
				sync		: item.sync,
				update_time	: item.update_time,
				visible		: item.visible,
				lock		: item.lock,
				panoId		: item.panoId,
				error_msg   : item.error_msg,
				repeated	: item.repeated,
				geometry	: item.geometry,
				syncRotate	: item.syncRotate,
				flatRoof	: item.flatRoof,
			});
		}
		
		//处理热点数据
		for(let key in data.hotspots){
			let item = data.hotspots[key];
			if(!item.id) data.hotspots.splice(key,1);
			if(!isNaN(item.id)) item.id = dyEditor.uuid();
			if(item.noimg) delete item.noimg;
			if(item.isNew) delete item.isNew;
			
			if(item.direction == undefined)			item.direction			= 0;
			if(item.align == undefined)				item.align 				= 0;
			if(item.followIcon == undefined)		item.followIcon 		= false;
			if(item.titleScale == undefined)		item.titleScale 		= 1;
			if(item.color == undefined)				item.color				= '#FFFFFF';
			if(item.backgroundColor == undefined)	item.backgroundColor	= '#000000';
			if(item.backgroundAlpha == undefined)	item.backgroundAlpha	= 0.5;
			// console.log('hhhhhh',item.mode);
			if(item.target){
				if(item.target.videos){
					for(let i=0; i<item.target.videos.length; i++){
						let video = item.target.videos[i];
						if(video.noimg) delete video.noimg;
					}
				} else if(item.target.musics){
					for(let i=0; i<item.target.musics.length; i++){
						let music = item.target.musics[i];
						//if(music.progress !=undefined) delete music.progress;
					}
				}
			} 
		}
		
		//处理自定义按钮数据
		for(let key in data.buttons){
			let item = data.buttons[key];
			if(!item.id) data.buttons.splice(key,1);
			if(item.noimg) delete item.noimg;
			if(item.target && item.target.videos){
				for(let i=0; i<item.target.videos.length; i++){
					let video = item.target.videos[i];
					if(video.noimg) delete video.noimg;
				}
			}
			//处理子按钮
			if(item.children){
				for(let key in item.children){
					let button = item.children[key];
					if(button.target && button.target.videos){
						for(let i=0; i<button.target.videos.length; i++){
							let video = button.target.videos[i];
							if(video.noimg) delete video.noimg;
						}
					}
				}
			}
		}
		
		//处理视角数据
		if(data.init.mode == 'pano' 
			&& dyEditor.pano.count('pano')<=0
			&& dyEditor.pano.count('fly')>0){
			data.init.mode = 'fly';
		}
		
		
		return json;
	}
	
	//获取所有资源总容量
	static getSize(){
		let json	= this.toJSON();
		let total	= Number(getTotalSize(json, 0));
		let panos	= Number(getTotalSize(json.panos, 0));
		let models	= Number(getTotalSize(json.models, 0));
		
		return {
			project	: panos + models,
			user	: total - panos - models,
		}
	}
}